/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Component, Input } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Component({
    selector: 'dash-gis-number-field',
    templateUrl: './number-field.component.html',
    styleUrls: ['./number-field.component.scss'],
    imports: [DecimalPipe],
})
export class NumberFieldComponent {
    @Input() public rowData: any;
    @Input() public fieldDefinition: any;
}
